import classNames from 'classnames';
import { List } from 'yoso';
import { BaseError } from '~/components/Error/BaseError';
import { MissionCard } from '~/components/Mission/Card/MissionCard';
import { useMissionGroup, useMissionPageParams } from '~/components/Mission/Mission.hooks';
import styles from './MissionExploreList.module.scss';

export type MissionExploreListProps = {
  className?: string;
};

export const MissionExploreList = ({ className }: MissionExploreListProps) => {
  const { status } = useMissionPageParams();
  const { data, isFetched } = useMissionGroup();

  if (isFetched && data[status].length === 0) throw new BaseError('EMPTY');

  return (
    <List className={classNames(styles.root, className)}>
      {data[status].map((each) => (
        <li key={each.id}>
          <MissionCard {...each} />
        </li>
      ))}
    </List>
  );
};
